import { Button, Typography } from "@plum-xoxo/admin-dsm";
import React, { useEffect, useState } from "react";
import { Turnstile } from "@plum-xoxo/turnstile_captcha";
import { TURNSTILE_SITE_KEY } from "../../../constants/AppConstant";
import config from "config";

const data = {
  domainExists: {
    heading: "Your company is already registered with us",
    centerText: "is already registered with us. How would you like to proceed?",
    button1: "Continue to redeem rewards",
    button2: "or Continue to create admin account",
  },
  xoxoCodeAndPointUser: {
    heading: "You have already been rewarded",
    centerText: "has already been rewarded. How would you like to proceed?",
    button1: "Visit marketplace to redeem reward",
    button2: "or Continue to create admin account",
  },
  xoxocodeUser: {
    heading: "You have already been rewarded",
    centerText: "has already been rewarded. How would you like to proceed?",
    button1: "Visit marketplace to redeem reward",
    button2: "or Continue to create admin account",
  },
  xoxopointUser: {
    heading: "You have already been rewarded",
    centerText: "has already been rewarded. How would you like to proceed?",
    button1: "Login to redeem reward",
    button2: "or Continue to create admin account",
  },
  userAlreadyExists: {
    heading: "You already have an account with us",
    centerText:
      "is already used for another account. How would you like to proceed?",
    button1: "Log in to your existing account",
    button2: "or Sign up with different email address",
  },
  disposableEmail: {},
};
const UserExists = ({
  associationError,
  email,
  button1Action,
  button2Action,
  showCts,
}) => {
  const url = config.storeFrontUrl.replace(/\/$/g, "");
  const {
    heading = "",
    centerText = "",
    button1 = "",
    button2 = "",
  } = data[associationError];
  const [renderTurnstileCaptcha, setRenderTurnstileCaptcha] = useState(false);
  return (
    <div className="d-flex flex-column gap-28">
      <div>
        <Typography.H1 className="mb-8">{heading}</Typography.H1>
        {email && (
          <Typography className="mb-0">
            <Typography.ButtonText
              component="span"
              color={"dark"}
              shade={"c300"}
            >
              {associationError === "domainExists"
                ? `@${email.split("@")[1]}`
                : email}
            </Typography.ButtonText>{" "}
            {centerText}
          </Typography>
        )}
      </div>
      <div className="d-flex flex-column gap-16">
        <Button className="w-100" size={"large"} onClick={button1Action}>
          {button1}
        </Button>

        {renderTurnstileCaptcha ? (
          <Turnstile
            siteKey={TURNSTILE_SITE_KEY}
            options={{ theme: "light" }}
            onSuccess={(token) => {
              button2Action(token);
            }}
          />
        ) : (
          <Button
            variant="outlined"
            className="w-100"
            size={"large"}
            onClick={() => {
              if (showCts) setRenderTurnstileCaptcha(true);
              else button2Action("");
            }}
          >
            {button2}
          </Button>
        )}
      </div>
      {associationError === "userAlreadyExists" ? null : (
        <div className="d-flex align-items-center">
          <Typography.LabelText
            color="dark"
            shade="c200"
            className="mt-12 pr-2"
          >
            Already have an account?{" "}
          </Typography.LabelText>
          <Button
            variant="plain"
            className="p-0 ps-1 mt-12"
            onClick={() => (window.location.href = url + `/marketplace/login`)}
          >
            Log in
          </Button>
        </div>
      )}
    </div>
  );
};

export default UserExists;
